import React from "react";

import { Stack, Box } from '@mui/material';


export const MstressIndexBar = ({ rangeVal, barsValues }) => {


    return (

        <Stack display='flex' flexDirection='row' fullWidth alignItems='center'>

            <Stack>

                <Box width={78} display='flex' flexDirection='row' justifyContent='space-between'>
                    <span className="range-txt opt-range-txt pb-3px">1</span>
                </Box>

                <Box className="range-box">

                    <Box className="range-point" style={{ display: rangeVal >= 1 && rangeVal <= 2 ? 'block' : 'none', marginLeft: '30px' }}></Box>

                    <Box className="optimal-range b-tb-l-radius c-range" width={78}></Box>

                </Box>


                <Box width={78} display='flex' flexDirection='row' justifyContent='center'>
                    <span className="range-txt opt-range-txt pt-3px">Optimal</span>
                </Box>
                
            </Stack>

            <Stack>
                <Box width={78} display='flex' flexDirection='row' justifyContent='space-between'>
                    <span className="range-txt opt-range-txt pb-3px">2</span>
                </Box>
                <Box className="range-box">

                    <Box className="range-point" style={{ display: rangeVal > 2 && rangeVal <= 3 ? 'block' : 'none', marginLeft: '30px' }}></Box>


                    <Box className="normal-range c-range" width={78}></Box>

                </Box>
                <Box width={78} display='flex' flexDirection='row' justifyContent='center'>
                    <span className="range-txt opt-range-txt pt-3px">Normal</span>
                </Box>
            </Stack>


            <Stack>
                <Box width={78} display='flex' flexDirection='row' justifyContent='space-between'>
                    <span className="range-txt opt-range-txt pb-3px">3</span>
                </Box>
                <Box className="range-box">

                    <Box className="range-point" style={{ display: rangeVal > 3 && rangeVal <= 4 ? 'block' : 'none', marginLeft: '30px' }}></Box>

                    <Box className="elevated-range b-tb-r-radius-0 c-range" width={78}></Box>

                </Box>
                <Box width={78} display='flex' flexDirection='row' justifyContent='center'>
                    <span className="range-txt opt-range-txt pt-3px">High Normal</span>
                </Box>
            </Stack>


            <Stack>
                <Box width={78} display='flex' flexDirection='row' justifyContent='space-between'>
                    <span className="range-txt opt-range-txt pb-3px">4</span>
                    <span className="range-txt opt-range-txt pb-3px">5</span>
                </Box>
                <Box className="range-box">

                    <Box className="range-point" style={{ display: rangeVal > 4 && rangeVal <= 5 ? 'block' : 'none', marginLeft: '30px' }}></Box>

                    <Box className="elevated-range c-range" sx={{ background: '#F2BF3A !important' }} width={78}></Box>

                </Box>
                <Box width={78} display='flex' flexDirection='row' justifyContent='center'>
                    <span className="range-txt opt-range-txt pt-3px">Elevated</span>
                </Box>
            </Stack>

        </Stack>
    )
}